import React from 'react';
import { Github, Linkedin, Terminal } from 'lucide-react';
import { SiWhatsapp } from 'react-icons/si';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="border-t border-border bg-slate-50 dark:bg-slate-900/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center text-primary-foreground">
                <Terminal className="w-5 h-5" />
              </div>
              <span className="text-xl font-bold tracking-tight">Hemera<span className="text-blue-500">Tech</span></span>
            </div>
            <p className="text-muted-foreground max-w-xs text-sm">
              IT specialist - setups, tuning, and backend development. Providing practical infrastructure for modern projects via hello@hemeratech.nl.
            </p>
            <div className="flex gap-4">
              <a href="https://github.com/hemeraone" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors"><Github className="w-5 h-5" /></a>
              <a href="https://www.linkedin.com/in/martijnsmidt/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors"><Linkedin className="w-5 h-5" /></a>
              <a href="https://wa.me/31643019983" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-green-500 transition-colors"><SiWhatsapp className="w-5 h-5" /></a>
            </div>
          </div>
          <div>
            <h4 className="font-bold mb-4 text-sm uppercase tracking-widest">Navigation</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="#services" className="hover:text-primary">Services</a></li>
              <li><a href="#tech-stack" className="hover:text-primary">Tech Stack</a></li>
              <li><a href="#scenarios" className="hover:text-primary">Scenarios</a></li>
              <li><a href="#engagement" className="hover:text-primary">Engagement</a></li>
              <li><a href="#projects" className="hover:text-primary">Projects</a></li>
              <li><a href="#about" className="hover:text-primary">About</a></li>
              <li><a href="#contact" className="hover:text-primary">Contact</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-4 text-sm uppercase tracking-widest">About</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="#" className="hover:text-primary">HemeraTech</a></li>
              <li><a href="#" className="hover:text-primary">hello@hemeratech.nl</a></li>
              <li><a href="#" className="hover:text-primary">KvK: 98942719</a></li>
              <li><a href="#" className="hover:text-primary">BTW: NL003112540B37</a></li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            © {currentYear} HemeraTech. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}